module.exports = __webpack_public_path__ + "static/media/ic_service_white.7309b799.svg";